import React from 'react'
import { useState } from 'react'
import {AiFillCaretDown} from 'react-icons/ai'
import {AiFillCaretUp} from 'react-icons/ai';
const HelpusCard2 = ({header,content}) => {
    const [display,setDisplay]=useState('hidden');

    const displayAction=()=>{
        if(display==='hidden'){
            setDisplay('block');
        }else{
            setDisplay('hidden');
        }
    }
  return (
    <div>
         <div className='w-full py-1 px-2' >
            <h1 onClick={displayAction} className='text-md py-1 cursor-pointer flex items-center'><AiFillCaretDown className='mx-1 text-sky-500 inline'/> {header}</h1>
            <p className={`${display} py-1 text-sm text-gray-700 px-8 `}>{content}</p>
         </div> 
    </div>
  )
}

export default HelpusCard2